
export class CalendarSlotRange {
  start: string;
  end: string;

  constructor() {
    this.start = '';
    this.end = '';
  }
}
